import { useEffect, useState } from "react";
const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useToast } from "@/shadcnComponents/ui/use-toast";

import { z } from "zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/shadcnComponents/ui/form";
import { Input } from "@/shadcnComponents/ui/input";
import { Button } from "@/shadcnComponents/ui/button";
import { useNavigate } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shadcnComponents/ui/select";

import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { Calendar } from "@/shadcnComponents/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcnComponents/ui/popover";
import React from "react";
import { useStaticData } from "@/Providers/Data";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuCheckboxItem,
} from "@radix-ui/react-dropdown-menu";

interface ISelectProps {
  goals: string[];
}

const formSchema = z.object({
  companyName: z.string().min(2).max(50),
  websiteLink: z.string(),
  companyLogo: z.string(),
  minFollower: z.string(),
  minCollab: z.string(),
  formLink: z.string(),
  minchips: z.string(),
  profileVisible: z.string(),
});

export const AdminAddDeals = () => {
  const navigate = useNavigate();
  const [date, setDate] = React.useState<Date>();
  const [optEmail, setoptEmail] = useState(true);
  const staticData = useStaticData();
  const [goals, setgoals] = useState([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const { toast } = useToast();
  const [seconds, setSeconds] = useState(300); // 5 minutes in seconds
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [dealID, SetDealID] = useState(null);

  useEffect(() => {
    staticData?.getNewDataFromType("Goal / KPI").then((e) => {
      setgoals(e?.map((item) => item?.CollabGoalsName));
    });
  }, []);

  useEffect(() => {
    let interval = null;

    if (isTimerActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (!isTimerActive && seconds !== 0) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isTimerActive, seconds]);

  useEffect(() => {
    if (optEmail && seconds === 0) {
      SendMail();
    }
  }, [optEmail, seconds]);

  // 1. Define your form.
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      companyName: "",
      websiteLink: "",
      companyLogo: "",
      minFollower: "",
      minCollab: "",
      formLink: "",
      minchips: "",
      profileVisible: "",
    },
  });

  // 2. Define a submit handler.
  function onSubmit(values: z.infer<typeof formSchema>) {
    // Do something with the form values.
    // ✅ This will be type-safe and validated.
    const savedeals = async () => {
      const response = await fetch(`${host}/developer/createDeal`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Credentials": "true",
          "Content-Type": "application/json",
          jwtToken: localStorage.getItem("jwtTokenD"),
        },
        body: JSON.stringify({
          ...values,
          campaignGoal: selectedItems,
          Deadline: date,
          optEmail: optEmail,
        }),
      });
      const json = await response.json();

      if (json.success) {
        toast({
          title: "New deal saved successfully",
          description: "Check the list of deals",
        });
        SetDealID(json.newDeals?._id);
        if (optEmail) {
          setIsTimerActive(true);
          setSeconds(300);
        }
      } else {
        toast({
          variant: "destructive",
          title: "Uh oh! Something went wrong.",
          description: "There was a problem with your request.",
        });
        window.open("/developer/login", "_self");
      }
    };
    savedeals();
  }
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleSelectChange = (value: string) => {
    if (!selectedItems.includes(value)) {
      setSelectedItems((prev) => [...prev, value]);
    } else {
      const referencedArray = [...selectedItems];
      const indexOfItemToBeRemoved = referencedArray.indexOf(value);
      referencedArray.splice(indexOfItemToBeRemoved, 1);
      setSelectedItems(referencedArray);
    }
  };
  const isOptionSelected = (value: string): boolean => {
    return selectedItems.includes(value) ? true : false;
  };
  const SendTestMail = async () => {
    const response = await fetch(`${host}/developer/sendTestDealMail`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Credentials": "true",
        "Content-Type": "application/json",
        jwtToken: localStorage.getItem("jwtTokenD"),
      },
      body: JSON.stringify({
        Deadline: date,
      }),
    });
    const json = await response.json();

    if (json.success) {
      toast({
        title: "Test mail sent successfully ",
        description: "Check Inbox ",
      });
    } else {
      toast({
        variant: "destructive",
        title: "Uh oh! Something went wrong.",
        description: "There was a problem with your request.",
      });
    }
  };
  const SendMail = async () => {
    const response = await fetch(`${host}/developer/sendDealMail`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Credentials": "true",
        "Content-Type": "application/json",
        jwtToken: localStorage.getItem("jwtTokenD"),
      },
      body: JSON.stringify({
        minFollower: form.getValues("minFollower"),
        minCollab: form.getValues("minCollab"),
        Deadline: date,
        dealID: dealID,
      }),
    });
    const json = await response.json();

    if (json.success) {
      toast({
        title: "Mail sent successfully ",
      });
    } else {
      toast({
        variant: "destructive",
        title: "Uh oh! Something went wrong.",
        description: "There was a problem with your request.",
      });
    }
  };

  return (
    <div className=" w-full flex flex-col h-full gap-[10px] px-[10%] ">
      <div className="w-full flex justify-between ">
        <span className=" text-[24px] font-[700] leading-[24px] font-inter text-[#424242)] ">
          Add New Deal
        </span>
        <Button onClick={() => navigate("/developer/admin/deals")}>
          List of Brand Deal
        </Button>
      </div>
      <span className=" text-[16px] font-[400] leading-[16px] font-inter text-[#757575] ">
        Please fill the form to create new deal
      </span>
      <div className="flex w-full">
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="w-full flex flex-col gap-[20px] mt-[20px] "
          >
            {/* information */}
            <div className=" w-full flex items-end  gap-[8px] ">
              <FormField
                control={form.control}
                name="companyName"
                render={({ field }) => (
                  <FormItem className="w-full">
                    <FormLabel>Information</FormLabel>

                    <FormControl>
                      <Input placeholder="Brand Name" {...field} />
                    </FormControl>

                    {/* <FormDescription>
                  This is your public display name.
                </FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="websiteLink"
                render={({ field }) => (
                  <FormItem className="w-full">
                    <FormControl>
                      <Input placeholder="Website Link" {...field} />
                    </FormControl>

                    {/* <FormDescription>
                  This is your public display name.
                </FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
            <div className=" w-full flex items-end  gap-[8px] ">
              <FormField
                control={form.control}
                name="companyLogo"
                render={({ field }) => (
                  <FormItem className="w-full">
                    <FormControl>
                      <Input placeholder="Brand Logo" {...field} />
                    </FormControl>

                    {/* <FormDescription>
                  This is your public display name.
                </FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="outline"
                    className="flex w-full gap-2 justify-start"
                  >
                    <span>Select Campaign Goal</span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                  style={{ boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.09)" }}
                  className="w-56 flex flex-col bg-[#FFFFFF] z-[50] rounded-[6px] border-[1px] border-[#F1F5F9] p-[10px] "
                  onCloseAutoFocus={(e) => e.preventDefault()}
                >
                  <DropdownMenuLabel>Goals</DropdownMenuLabel>
                  <DropdownMenuSeparator />
                  {goals.map(
                    (value: ISelectProps["goals"][0], index: number) => {
                      return (
                        <DropdownMenuCheckboxItem
                          className={`cursor-pointer px-[8px] py-[6px]  ${
                            selectedItems.includes(value) ? "bg-[#F1F5F9]" : ""
                          }`}
                          onSelect={(e) => e.preventDefault()}
                          key={index}
                          checked={isOptionSelected(value)}
                          onCheckedChange={() => handleSelectChange(value)}
                        >
                          {selectedItems.includes(value) && <span>✓</span>}
                          {value}
                        </DropdownMenuCheckboxItem>
                      );
                    }
                  )}
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
            {/* eligibility */}
            <div className=" w-full flex items-end  gap-[8px] mt-[10px] ">
              <FormField
                control={form.control}
                name="minFollower"
                render={({ field }) => (
                  <FormItem className="w-full">
                    <FormLabel>Eligibility</FormLabel>

                    <FormControl>
                      <Input
                        type="number"
                        min={0}
                        placeholder="Minimum Followers"
                        {...field}
                      />
                    </FormControl>

                    {/* <FormDescription>
                  This is your public display name.
                </FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="minCollab"
                render={({ field }) => (
                  <FormItem className="w-full">
                    <FormControl>
                      <Select
                        onValueChange={field.onChange}
                        defaultValue={field.value}
                      >
                        <SelectTrigger className="w-full">
                          <SelectValue placeholder="Min Collaboration" />
                        </SelectTrigger>
                        <SelectContent>
                          {[
                            "0",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5",
                            "6",
                            "7",
                            "8",
                            "9",
                            "10",
                          ]?.map((item, index) => {
                            return (
                              <SelectItem key={index} value={item}>
                                {item}
                              </SelectItem>
                            );
                          })}
                        </SelectContent>
                      </Select>
                    </FormControl>

                    {/* <FormDescription>
                  This is your public display name.
                </FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
            {/* apply link */}
            <div className=" w-full flex items-end  gap-[8px] ">
              <FormField
                control={form.control}
                name="formLink"
                render={({ field }) => (
                  <FormItem className="w-1/2">
                    <FormLabel>Apply Link</FormLabel>
                    <FormControl>
                      <Input placeholder="Apply Link" {...field} />
                    </FormControl>

                    {/* <FormDescription>
                  This is your public display name.
                </FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
            {/* last date to apply */}
            <div className=" w-full flex items-end  gap-[8px] mt-[10px] ">
              <FormField
                control={form.control}
                name="minFollower"
                render={() => (
                  <FormItem className="w-full flex flex-col">
                    <FormLabel>Last Date to Apply</FormLabel>

                    <FormControl>
                      <Popover>
                        <PopoverTrigger asChild>
                          <Button
                            variant={"outline"}
                            className={cn(
                              "w-1/2 justify-start text-left font-normal",
                              !date && "text-muted-foreground"
                            )}
                          >
                            <CalendarIcon className="mr-2 h-4 w-4" />
                            {date ? (
                              format(date, "PPP")
                            ) : (
                              <span>Pick a date</span>
                            )}
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent className="w-auto p-0">
                          <Calendar
                            mode="single"
                            selected={date}
                            onSelect={setDate}
                            initialFocus
                          />
                        </PopoverContent>
                      </Popover>
                    </FormControl>

                    {/* <FormDescription>
                  This is your public display name.
                </FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
            {/* condition to show */}
            <div className=" w-full flex items-end  gap-[8px] mt-[10px] ">
              <FormField
                control={form.control}
                name="minchips"
                render={({ field }) => (
                  <FormItem className="w-full">
                    <FormLabel>Condition to show</FormLabel>

                    <FormControl>
                      <Input
                        type="number"
                        min={0}
                        placeholder="The creator must have Min chips"
                        {...field}
                      />
                    </FormControl>

                    {/* <FormDescription>
                  This is your public display name.
                </FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="profileVisible"
                render={({ field }) => (
                  <FormItem className="w-full">
                    <FormControl>
                      <Select
                        onValueChange={field.onChange}
                        defaultValue={field.value}
                      >
                        <SelectTrigger className="w-full">
                          <SelectValue
                            placeholder="Select Profile Visible"
                            {...field}
                          />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value={"true"}>true</SelectItem>
                          <SelectItem value="false">false</SelectItem>
                        </SelectContent>
                      </Select>
                    </FormControl>

                    {/* <FormDescription>
                  This is your public display name.
                </FormDescription> */}
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
            <div className=" w-full flex flex-col gap-[8px] mt-[10px]  ">
              <span className="text-[16px] font-[500] leading-[20px] font-inter text-[#424242]">
                Do you want to send an email about this deal? (Email will be
                sent after 5min of deal created)
              </span>
              <div className="flex gap-[8px]">
                <Button
                  onSubmit={null}
                  onClick={(e) => {
                    e.preventDefault();
                    setoptEmail(true);
                  }}
                  variant={`${!optEmail ? "outline" : "default"}`}
                >
                  Yes
                </Button>
                <Button
                  onSubmit={null}
                  onClick={(e) => {
                    e.preventDefault();
                    setoptEmail(false);
                  }}
                  variant={`${optEmail ? "outline" : "default"}`}
                >
                  No
                </Button>
              </div>
              <div className="flex gap-[8px]">
                {optEmail && (
                  <Button
                    onSubmit={null}
                    onClick={(e) => {
                      e.preventDefault();
                      SendTestMail();
                    }}
                    variant={`${!optEmail ? "outline" : "default"}`}
                  >
                    SEND TEST EMAILS
                  </Button>
                )}
              </div>
            </div>
            {optEmail && isTimerActive && (
              <h1>
                Sending new deal mail in: {formatTime(seconds)}{" "}
                <Button
                  onSubmit={null}
                  onClick={(e) => {
                    e.preventDefault();
                    setIsTimerActive(false);
                  }}
                >
                  Cancel
                </Button>
              </h1>
            )}
            <div className="w-full  ">
              <Button>Submit</Button>
            </div>
          </form>
        </Form>
      </div>
    </div>
  );
};
